import React, { useState } from 'react';
import { ReactComponent as SalesgearIcon } from 'Assets/svg/export_icons/salesgear.svg';
import { ReactComponent as QuestionMark } from 'Assets/svg/question-mark.svg';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon.svg';
import profileState from 'Stores/profile';
import * as CONSTANTS from 'Utils/constants';
import CRMExportHeader from '../common/ExportLeads/crmExportComponents';
import HocPopupComponent from '../common/hocPopupComponent';
import Input from '../common/newInputField';
import CancelSaveButton from '../common/CancelSaveButton';
import LoadingWrapper from '../common/loadingWrapper';

const SalesgearAPIConnect = props => {
  const { closePopup, saveButtonText = 'Export' } = props;
  const [showConnectSteps, setShowConnectSteps] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [formData, setFormData] = useState({ value: '', error: '' });

  const handleSave = async () => {
    if (formData.value !== '') {
      setShowLoader(true);
      const isSuccess = await profileState.connectToSalesgear(formData.value);
      setShowLoader(false);
      if (isSuccess) closePopup(true);
    } else {
      setFormData({ ...formData, error: 'Please enter your API key' });
    }
  };

  return (
    <>
      <LoadingWrapper
        position="fixed"
        show={showLoader}
        className="salesgear-api-load"
      />
      <HocPopupComponent
        customClassName="salesgear-api-popup"
        allowMaskClick
        showCloseIcon
        closeClick={closePopup}
      >
        <CRMExportHeader
          Logo={SalesgearIcon}
          title="Salesgear Export"
          message="Now use your Salesgear API Key for connecting with Adapt"
        />
        <div className="popup-body">
          <Input
            inputProps={{
              type: 'text',
              name: 'salesgearKey',
              id: 'apikey',
              placeholder: 'Enter Salesgear API Key here.',
              onChange: value => {
                setFormData({
                  error:
                    formData.error !== '' && value !== '' ? '' : formData.error,
                  value,
                });
              },
              value: formData.value,
              required: true,
            }}
            error={formData.error}
            className="api-key-wrap"
            label="API Key"
          />
          {showConnectSteps && (
            <div className="connect-section">
              <div className="question-title">
                Know how to get Salesgear API Key
              </div>
              <ul className="connect-steps">
                <li>
                  <TickIcon />
                  <span className="span-mr">Login to your</span>
                  <a
                    href={`${CONSTANTS.SALESGEAR_URL}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Salesgear
                  </a>
                  <span className="span-ml span-mr">
                    account and navigate to the
                  </span>
                  <a
                    href={`${CONSTANTS.SALESGEAR_URL}/settings/profile`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    settings page
                  </a>
                  .
                </li>
                <li>
                  <TickIcon />
                  <span>Copy the API key from the Salesgear settings page</span>
                </li>
                <li>
                  <TickIcon />
                  <span>
                    Add the API key to the text box above and click on Export.
                  </span>
                </li>
              </ul>
            </div>
          )}
        </div>
        <div
          className={`footer-section${showConnectSteps ? ' only-button' : ''}`}
        >
          {!showConnectSteps && (
            <div className="question" onClick={() => setShowConnectSteps(true)}>
              <span>How to get API Key</span>
              <QuestionMark />
            </div>
          )}
          <CancelSaveButton
            handleSave={handleSave}
            handleCancel={closePopup}
            saveButtonText={saveButtonText}
          />
        </div>
      </HocPopupComponent>
    </>
  );
};

export default SalesgearAPIConnect;
